import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';

const MouseParallax = ({ children, strength = 20 }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const springConfig = { damping: 25, stiffness: 150 };

  const x = useSpring(0, springConfig);
  const y = useSpring(0, springConfig);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      const xPos = (e.clientX / innerWidth - 0.5) * strength;
      const yPos = (e.clientY / innerHeight - 0.5) * strength;
      x.set(xPos);
      y.set(yPos);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [strength, x, y]);

  const rotateX = useTransform(y, [strength * -1, strength], [5, -5]);
  const rotateY = useTransform(x, [strength * -1, strength], [-5, 5]);

  return (
    <motion.div style={{ x, y, rotateX, rotateY, perspective: 1000 }} className="w-full h-full">
      {children}
    </motion.div>
  );
};

export default MouseParallax;